import { render, staticRenderFns } from "./SidenavDivider.vue?vue&type=template&id=b6fd9ece&"
import script from "./SidenavDivider.vue?vue&type=script&lang=js&"
export * from "./SidenavDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6fd9ece')) {
      api.createRecord('b6fd9ece', component.options)
    } else {
      api.reload('b6fd9ece', component.options)
    }
    module.hot.accept("./SidenavDivider.vue?vue&type=template&id=b6fd9ece&", function () {
      api.rerender('b6fd9ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/vendor/libs/sidenav/SidenavDivider.vue"
export default component.exports